import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import { Reveal, Overline } from "./Reveal";

const FAQS = [
  {
    q: "Is this a course, or done-for-you?",
    a: "Neither. You own the business and you do the work — our operators sit beside you. Daily support Monday to Friday in your private client channel, four one-to-one checkpoint reviews, and complete written playbooks for every stage.",
  },
  {
    q: "Why $6,997 when you charge $25,000?",
    a: "Done-for-you means our team builds and runs everything — that's $25,000. For our 10th anniversary, we're teaching 10 people to do what we do, with six months of direct access to the team. When the ten seats are claimed, the offer closes.",
  },
  {
    q: "What if I don't reach $10,000 in six months?",
    a: "Complete every checkpoint, and if you haven't reached $10,000 in gross Amazon sales in six months, we keep working with you at no additional cost until you do. It is a commitment to continue coaching — not a guarantee of income, profit, or results.",
  },
  {
    q: "What do I need to get started?",
    a: "At least $5,000 in working capital for inventory, separate from the $6,997 program fee, plus the time to execute each stage. Without deployable capital the program cannot be completed.",
  },
  {
    q: "Who is this for?",
    a: "Ten people who want proven operators beside them instead of another course. Every seat starts with a 45-minute one-to-one onboarding call where we map your six months and confirm the fit.",
  },
];

export function Faq() {
  const [open, setOpen] = useState(0);
  return (
    <section data-testid="faq-section" className="border-t border-black/10 bg-white">
      <div className="mx-auto max-w-[1600px] px-5 py-32 md:px-10 md:py-48">
        <div className="grid gap-16 lg:grid-cols-12">
          <Reveal className="lg:col-span-4">
            <Overline>Questions</Overline>
            <h2 className="mt-6 font-display text-4xl font-black tracking-tighter sm:text-5xl">
              Everything you're wondering.
            </h2>
          </Reveal>
          <div className="lg:col-span-8">
            {FAQS.map((f, i) => (
              <Reveal key={f.q} delay={i * 0.05}>
                <div className="border-b border-black/10">
                  <button
                    data-testid={`faq-question-${i}`}
                    onClick={() => setOpen(open === i ? -1 : i)}
                    aria-expanded={open === i}
                    className="flex w-full items-center justify-between gap-6 py-7 text-left"
                  >
                    <span className="font-display text-xl font-bold tracking-tight md:text-2xl">
                      {f.q}
                    </span>
                    <Plus
                      className={`h-5 w-5 shrink-0 text-signal transition-transform duration-300 ${
                        open === i ? "rotate-45" : ""
                      }`}
                    />
                  </button>
                  <AnimatePresence initial={false}>
                    {open === i && (
                      <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
                        className="overflow-hidden"
                      >
                        <p
                          data-testid={`faq-answer-${i}`}
                          className="max-w-2xl pb-7 font-body text-sm leading-relaxed text-ink/60"
                        >
                          {f.a}
                        </p>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
